"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _propTypes = require("prop-types");

var _reactFeather = require("react-feather");

var _Quotes = _interopRequireDefault(require("./Quotes"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var container = function container(primaryColor) {
  return /*#__PURE__*/(0, _emotion.css)("font-family:'Open Sans',-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Noto Sans','Ubuntu','Droid Sans','Helvetica Neue',sans-serif;width:100%;display:flex;align-items:center;flex-direction:column;position:relative;&:focus,&:active{outline:0;}.arrow{background:", primaryColor, ";color:#2d1a5a;padding:10px;border-radius:50%;display:flex;align-items:center;justify-content:center;position:absolute;top:50%;z-index:2;cursor:pointer;transform:translateY(-50%);transition:all ease 0.2s;box-shadow:0 0px 4px 1px rgba(0,0,0,0.3);@media (max-width:576px){padding:6px;}}.arrow:hover{box-shadow:0 1px 1px rgba(0,0,0,0.2);}.arrow.left{left:0px;@media (max-width:576px){left:33%;top:110%;}}.arrow.right{right:0px;@media (max-width:576px){right:33%;top:110%;}}");
};

var testimonial = function testimonial() {
  return /*#__PURE__*/(0, _emotion.css)("width:70%;background:white;border:1px solid #e8e8e8;border-radius:5px;box-shadow:1px 2px 5px rgba(0,0,0,0.05);padding:20px;position:relative;@media (max-width:576px){width:90%;}@media (max-width:320px){width:100%;padding:10px;.quotes{width:25px;height:25px;}}@keyframes show{from{opacity:0;}to{opacity:1;}}p{width:90%;margin:40px auto;text-align:center;color:#595959;opacity:0;animation:show 0.5s forwards ease-in;}.avatar{margin:10px auto;width:80%;display:flex;flex-direction:column;align-items:center;justify-content:center;opacity:0;animation:show 0.5s forwards ease;animation-delay:0.4s;.image{width:50px;height:50px;border-radius:50%;overflow:hidden;img{margin:0 auto;max-width:100%;max-height:100%;}}h4{margin:15px 0 5px;font-weight:400;color:#262626;}h5{margin:0;font-weight:400;color:#8c8c8c;}}.quotes{position:absolute;width:40px;z-index:0;}.quotes.start{transform:rotate(180deg);top:20px;left:20px;}.quotes.end{bottom:20px;right:20px;}");
};

var Testimonials = /*#__PURE__*/function (_React$Component) {
  function Testimonials() {
    var _temp, _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_temp = _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this, _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      selectedIndex: 0
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleNext", function () {
      var selectedIndex = _this.state.selectedIndex;
      var testimonials = _this.props.testimonials;
      var nextIndex = selectedIndex + 1;

      if (selectedIndex === testimonials.length - 1) {
        nextIndex = 0;
      }

      _this.setState({
        selectedIndex: nextIndex
      });
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handlePrevious", function () {
      var selectedIndex = _this.state.selectedIndex;
      var testimonials = _this.props.testimonials;
      var nextIndex = selectedIndex - 1;

      if (selectedIndex === 0) {
        nextIndex = testimonials.length - 1;
      }

      _this.setState({
        selectedIndex: nextIndex
      });
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKey", function (e) {
      if (e.key === 'ArrowLeft') {
        _this.handlePrevious();
      }

      if (e.key === 'ArrowRight') {
        _this.handleNext();
      }
    }), _temp) || _assertThisInitialized(_this);
  }

  var _proto = Testimonials.prototype;

  _proto.render = function render() {
    var selectedIndex = this.state.selectedIndex;
    var _this$props = this.props,
        testimonials = _this$props.testimonials,
        primaryColor = _this$props.primaryColor;
    var item = testimonials[selectedIndex];
    return _react.default.createElement("div", {
      className: container(primaryColor),
      role: "button",
      tabIndex: "0",
      onKeyDown: this.handleKey
    }, testimonials.length > 1 && _react.default.createElement("div", {
      className: "arrow left",
      onClick: this.handlePrevious,
      role: "button",
      tabIndex: "0",
      onKeyDown: this.handleKey
    }, this.props.leftIcon), _react.default.createElement("div", {
      key: item.from,
      className: testimonial(primaryColor)
    }, _react.default.createElement("div", {
      className: "quotes start"
    }, _react.default.createElement(_Quotes.default, {
      fill: primaryColor
    })), _react.default.createElement("div", {
      className: "quotes end"
    }, _react.default.createElement(_Quotes.default, {
      fill: primaryColor
    })), _react.default.createElement("p", null, item.description), _react.default.createElement("div", {
      className: "avatar"
    }, _react.default.createElement("div", {
      className: "image"
    }, _react.default.createElement("img", {
      src: item.image,
      alt: item.from
    })), _react.default.createElement("h4", null, item.from), _react.default.createElement("h5", null, item.role))), testimonials.length > 1 && _react.default.createElement("div", {
      className: "arrow right",
      onClick: this.handleNext,
      role: "button",
      tabIndex: "0",
      onKeyDown: this.handleKey
    }, this.props.rightIcon));
  };

  _inheritsLoose(Testimonials, _React$Component);

  return Testimonials;
}(_react.default.Component);

Testimonials.defaultProps = {
  primaryColor: 'red',
  leftIcon: _react.default.createElement(_reactFeather.ChevronLeft, null),
  rightIcon: _react.default.createElement(_reactFeather.ChevronRight, null)
};
Testimonials.propTypes = {
  style: _propTypes.object,
  className: _propTypes.string,
  testimonials: _propTypes.array,
  rightIcon: _propTypes.object,
  leftIcon: _propTypes.object,
  primaryColor: _propTypes.string
};
var _default = Testimonials;
exports.default = _default;